import { Controller } from "@hotwired/stimulus"

// Bot protection - adds JavaScript challenge that bots without JS can't pass
export default class extends Controller {
  static targets = ["token"]

  connect() {
    // Add a JS-generated component to the token after a small delay
    // This ensures JavaScript is actually executed
    setTimeout(() => {
      if (this.hasTokenTarget) {
        const currentToken = this.tokenTarget.value
        const jsProof = this.generateJsProof()
        this.tokenTarget.value = `${currentToken}|${jsProof}`
      }
    }, 500)
  }

  generateJsProof() {
    // Generate a simple proof that JS was executed
    const timestamp = Date.now()
    const random = Math.random().toString(36).substring(2, 10)
    return btoa(`js:${timestamp}:${random}`)
  }
}
